import React from "react";
//#region types
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { SelfInvoiceFormGeneralSectionExpandableProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import { ExpandableSection, ExpandableSectionSummary } from "components/common/wintForms";
import SelfInvoiceFormGeneralFields from "./generalFields";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SelfInvoiceFormGeneralSectionExpandable: React.FC<
  SelfInvoiceFormGeneralSectionExpandableProps<InvoiceFormTypes.SelfInvoice>
> = (props) => {
  const { connect } = props;

  const customerSearchProps = connect("customer");
  const invoiceDateProps = connect("invoiceDate");
  const oCRNumberProps = connect("oCRNumber");

  return (
    <ExpandableSection
      summary={
        <ExpandableSectionSummary
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SelfInvoiceDetails)}
        />
      }
      initiallyOpen
      hasErrors={customerSearchProps.hasError || invoiceDateProps.hasError || oCRNumberProps.hasError}
      {...props.expandableStepProps}
    >
      <SelfInvoiceFormGeneralFields connect={connect} />
    </ExpandableSection>
  );
};

export default SelfInvoiceFormGeneralSectionExpandable;
